import React from "react";

const Blogs = () => {
  return <div><a href="https://gianedavicollezioni.com/admintoys/mageplaza_blog/post/">Go to Magento Blog</a></div>;
};

export default Blogs;
